// extracted by mini-css-extract-plugin
export default {"notification":"Notification_notification__rQccJ","notificationText":"Notification_notificationText__mA7wM"};